import style from "./Inputs.module.css";

const InputRadio = ({
  children = [],
  label,
  props,
  radioImage = false,
  radioColor = false,
  combined = false,
}: componentProps) => {
  return (
    <div className={style.input_container}>
      {combined ? (
        <div className={style.input_radio_container}>
          {children.map((item, index) => (
            <label key={index}>
              <input type="radio" value={item.value} {...props} />
              <span>{item.name}</span>
            </label>
          ))}
        </div>
      ) : (
        <>
          {label && <label>{label}</label>}
          <div className={style.input_radio__children}>
            <div className="row">
              {children.map((item, index) => (
                <div key={index} className="col-lg-4 col-md-3 col-sm-4 col-6">
                  <div
                    className={`${style.input_radio} ${radioImage || radioColor ? style["input_radio--image"] : ""}`}
                  >
                    <input type="radio" value={item.value} {...props} />
                    <div
                      className={`${style.input_radio_memic} ${
                        radioImage || radioColor ? style.input_radio_image_memic : ""
                      }`}
                    >
                      {(radioImage || radioColor) && (
                        <div>
                          {radioImage && <img src={item.image} alt="" />}
                          {radioColor && <span style={{ backgroundColor: item.color }}></span>}
                        </div>
                      )}
                      {item.name}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default InputRadio;

export type RadioOption = {
  value: string | boolean | number;
  name: string;
  image?: string;
  color?: string;
};

type componentProps = {
  props: any;
  children: RadioOption[];
  label?: string;
  radioImage?: boolean;
  radioColor?: boolean;
  combined?: boolean;
};
